// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3U9gwI3nRVe6zd {\n  text-align: center;\n  margin-bottom: 12px;\n}\n.TjOp__Wm3Qae9F {\n  margin-bottom: 0;\n}\n._1i0Y-IbMbVvjvh {\n  flex: 1 1 auto;\n  z-index: 1;\n  min-height: 0;\n  padding-top: 1px;\n}\n._3fN65Lj6sGux4k {\n  display: flex;\n}\n._2y59qH0RwBBnID {\n  width: 100%;\n  margin-bottom: 8px;\n  min-height: 56px;\n}\n._1EL4q0gyUBbD_E,\n._2Z6UPrKY1is0S1 {\n  margin-top: 8px;\n  margin-bottom: 0;\n}\n._1kkaiCmPPBHiPm {\n  text-decoration: none;\n}\n._3_hacFB7NkKHaf {\n  display: flex;\n  flex-direction: column;\n  margin-left: 8px;\n}\n._3_hacFB7NkKHaf ._1tXWlXM8sKLHNX {\n  width: 32px;\n  padding: 6px 8px;\n  margin-bottom: 8px;\n}\n._3_hacFB7NkKHaf ._1tXWlXM8sKLHNX:focus {\n  outline: -webkit-focus-ring-color auto 1px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyStateMessage": "_3U9gwI3nRVe6zd",
	"createNewTemplateButton": "TjOp__Wm3Qae9F",
	"templateCards": "_1i0Y-IbMbVvjvh",
	"templateCardContainer": "_3fN65Lj6sGux4k",
	"templateCard": "_2y59qH0RwBBnID",
	"editTemplatesButton": "_1EL4q0gyUBbD_E",
	"finishEditingButton": "_2Z6UPrKY1is0S1",
	"noTextDecoration": "_1kkaiCmPPBHiPm",
	"controlButtons": "_3_hacFB7NkKHaf",
	"controlButton": "_1tXWlXM8sKLHNX"
};
export default ___CSS_LOADER_EXPORT___;
